export default __webpack_public_path__ + "static/media/Mulch.398d562d.png";